import { getLanguage } from '../getLanguage';

export const pluralize = (
  count: number,
  words: {
    one: string;
    few: string;
    many: string;
    zero: string;
    two: string;
    other: string;
  }
): string => {
  const rules = new Intl.PluralRules(getLanguage());

  const category = rules.select(count);

  return words[category] || words['many'];
};
